import './markerDetailCard.scss';
import React, { useState, useRef, useMemo } from 'react';
import { set } from 'redux/slices/plannerSegmentsSlice';
import styled from 'styled-components';
import SvgIcon from 'components/commons/icons/SvgIcon';
import Button from 'components/commons/buttons/button/Button';
import { Popup } from 'react-leaflet';
import { ReactComponent as Ic_Star } from 'resources/icons/Ic_Star.svg';
import { ReactComponent as Ic_Star_white } from 'resources/icons/Ic_Star_white.svg';
import { ReactComponent as Ic_Nav } from 'resources/icons/Ic_Navigation.svg';
import { ReactComponent as Ic_Location_White } from 'resources/icons/Ic_Location_White.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RUTAS_GENERALES_MUL2, POI_DEFAULT_BACKGROUND } from 'utils/constants';
import { useFavorites } from 'hooks/useFavorites/useFavorites';
import SaveFavoriteModal from 'screens/favoritesScreen/components/modals/saveFavoriteMoodal/SaveFavoriteModal';
import ModalDelete from 'components/commons/modal/modalDelete/ModalDelete';
import { updateContextualMessage } from 'redux/slices/contextualSlice';
import UseSEO from 'hooks/useSEO/UseSEO';
import { useTranslate } from 'context/languageContext';
import { poiCategoryIconsState } from 'redux/slices/iconsSlice';
import { useSelector } from 'react-redux';
import { poisFavoritesState } from 'redux/slices/favoritesSlice';
import { useEffect } from 'react';
import { updateOnMapClick } from 'redux/slices/mapSlice';

interface IMarkerDetailCard {
  marker: any;
  onClose?: () => void;
}

const MarkerDetailCard = ({ marker, onClose }: IMarkerDetailCard) => {
  const BACKGROUND = marker?.data?.iconPoiCategory?.color || POI_DEFAULT_BACKGROUND;
  const popupRef = useRef<any>(null); // Referencia para manejar el cierre del popup
  const StyledPopup = styled(Popup)`
    .leaflet-popup-content-wrapper {
      background: ${BACKGROUND}!important;
    }
    .leaflet-popup-content-wrapper,
    .leaflet-popup-tip {
      background: ${BACKGROUND}!important;
    }
  `;

  const selectorPoiCategoryIcons = useSelector(poiCategoryIconsState);
  const t = useTranslate();
  const [showDelete, setShowDelete] = useState(false);
  const [showFavorite, setShowFavorite] = useState(false);
  const favoritePoisSelector = useSelector(poisFavoritesState);
  const navigate = useNavigate();
  const [generateUrl] = UseSEO();
  const dispatch = useDispatch();
  const { saveFavorites, deleteFavorites, isFavorite } = useFavorites();
  const [myPoi, setMyPoi] = useState({
    id: marker.id,
    name: marker.name,
    address: marker.address,
    categoryId: marker.poiCategoryId,
  });
  const isIcon = selectorPoiCategoryIcons?.find(
    (icon) => icon.id === marker?.data?.iconPoiCategory?.iconId,
  );
  const ICON = isIcon?.contentFile;

  const handleFavorite = () => {
    if (isFavorite('pois', marker?.id)) {
      setShowDelete(true);
    } else {
      try {
        setShowDelete(false);
        setShowFavorite(true);
      } catch (error) {
        dispatch(
          updateContextualMessage({
            message: 'No se pudo agregar el punto de interés.',
            type: 'error',
          }),
        );
      }
    }
  };

  const onClickNaV = () => {
    dispatch(set({ index: 1, overwrite: false, stop: marker }));
    setTimeout(() => {
      navigate(generateUrl(RUTAS_GENERALES_MUL2.planner, 'PLAN', [marker]));
    }, 300);
  };

  // Manejar el cierre del popup manualmente
  const handleManualClose = () => {
    if (popupRef.current) {
      popupRef.current.remove(); // Cierra el popup usando la referencia de Leaflet
      onClose && onClose();
    }
  };

  useEffect(()=>{
    if(showFavorite) dispatch(updateOnMapClick(null));
    if(!showFavorite) dispatch(updateOnMapClick(onClose));
    return ()=> {
      dispatch(updateOnMapClick(null));
    };
  },[showFavorite]);

  const myPopUp = useMemo(()=>
    <StyledPopup
      className='contact-marker-popup'
      key={'CardItemCategory' + marker.id + String(isFavorite('pois', marker?.id))}
      closeButton={false} // Desactiva el botón de cierre por defecto
      autoClose={false}
      closeOnClick={false}
      ref={popupRef} // Asigna la referencia al popup
    >
      <div className='popup-btn-close' onClick={handleManualClose}>
        x
      </div>
      <div
        className='detail-marker-card'
        id={`emt-marker-card-${marker.id}`}
        // onClick={(e) => {
        //   marker.onClick && marker.onClick();
        // }}
        style={{ background: BACKGROUND }}
      >
        <div className='icon-box'>
          {ICON ? (
            <img src={ICON} alt='detail-marker-icon' />
          ) : (
            <SvgIcon ariaLabel='icono-code-poi' Icon={Ic_Location_White} />
          )}
        </div>
        <div className='info-box'>
          <h3>{marker.name}</h3>
          <p>{marker.description || marker.address}</p>
        </div>

        <div className='btn-box'>
          <Button
            icon={Ic_Nav}
            className='btn-nav'
            height='38px'
            width='38px'
            onClick={() => onClickNaV()}
          />
          <Button
            icon={isFavorite('pois', marker?.id) ? Ic_Star: Ic_Star_white}
            className='btn-fav'
            height='38px'
            width='38px'
            background={isFavorite('pois', marker?.id) ? '#FFF': BACKGROUND}
            style={{ border: 'solid 2.5px white' }}
            onClick={() => handleFavorite()}
          />
        </div>
      </div>
    </StyledPopup>
  ,[favoritePoisSelector]);

  return (
    <>
      {myPopUp}
      {showDelete && (
        <ModalDelete
          onClose={() => setShowDelete(false)}
          text={`${t('lb_favorites_seguro_eliminar_destino')} "${marker.name}"`}
          onAccept={() =>
            deleteFavorites(
              Number(marker.categoryId) === 1 ? 'directions' : 'pois',
              [marker.id],
              () => setShowDelete(false),
            )
          }
        />
      )}
      {showFavorite && (
        <SaveFavoriteModal
          onClose={() => setShowFavorite(false)}
          title={t('lb_favorites_guardar_destino_interrogante')}
          text={t('lb_favorites_guardar_destino_main')}
          secondaryText={t('lb_favorites_guardar_secondary')}
          onAccept={() => saveFavorites('pois', [myPoi], () => setShowFavorite(false))}
          onAliasChange={(a) => setMyPoi(a)}
          onIconChange={(c) => setMyPoi(c)}
          item={myPoi}
        />
      )}
    </>
  );
};

export default React.memo(MarkerDetailCard);
